import React from 'react'

/* eslint-disable-next-line jsx-a11y/anchor-has-content */
export const Link = props => <a {...props} className={props.className || 'text-teal-600'} />
